import { Map } from 'immutable'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import { GET_SETTINGS, UPDATE_SETTINGS } from './actions'

const INITIAL_STATE = new Map()

export const settings = createReducer(INITIAL_STATE, {
  [GET_SETTINGS.FULFILLED]: (state, { payload }) => state.mergeDeep({ ...payload }),

  [UPDATE_SETTINGS.FULFILLED]: (state, { payload }) => new Map(payload),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/settings/reducers.js